import LeftMenuComponent from 'srs.sharedcomponents/lib/esm/shared-components/srs.leftMenu.component'
import {
  useAppDispatch,
  useAppSelector,
} from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { Container, Row, Col } from 'react-bootstrap'
import { useEffect } from 'react'
import {
  resetStatus,
  status as reduxStatus,
} from 'srs.sharedcomponents/lib/esm/redux/slices/webPartEditorSlice'
import { getWelcome } from 'srs.sharedcomponents/lib/esm/redux/slices/welcomeSlice'
import { stateStatusWebPartEditor } from 'srs.sharedcomponents/lib/esm/utils/enums'
import CustomModelComponent from 'srs.sharedcomponents/lib/esm/components/builder/CustomModelComponents/CustomModelComponent'

interface IEsstComponentProps {
  isLeftSideMobileMenuExpand?: boolean
  toggleLeftSideMobileMenu?: () => void
}

const EsstComponent = (props: IEsstComponentProps) => {
  const leftNavEnabled = true
  const welcome = useAppSelector((state) => state?.welcome?.welcome)

  const dispatch = useAppDispatch()
  const reduxStateStatus = useAppSelector(reduxStatus)

  useEffect(() => {
    if (reduxStateStatus === stateStatusWebPartEditor.promoteFulfilled) {
      dispatch(getWelcome())
      dispatch(resetStatus())
    }
  }, [reduxStateStatus])

  if (!welcome || welcome.anonymousId === '') return <></>
  return (
    <Container>
      <main id="main" role="main" className="pb-3">
        <Row>
          {leftNavEnabled && (
            <Col
              className={`${
                props.isLeftSideMobileMenuExpand ? '' : 'd-none '
              } d-xl-block d-lg-block`}
            >
              <LeftMenuComponent
                items={welcome.leftCatalog}
                toggleLeftSideMobileMenu={props.toggleLeftSideMobileMenu}
              />
            </Col>
          )}
          <Col
            md={12}
            lg={leftNavEnabled ? 9 : 12}
            xl={leftNavEnabled ? 9 : 12}
          >
            <Row>
              <div
                className="col-md-8 col-sm-8 first-image position-relative"
                id="welcomeZoneImage"
              >
                <CustomModelComponent
                  key={'/pages/esst'}
                  modelKey="pages"
                  modelName="pages"
                  path={'/pages/esst'}
                  disableUniqueModelKey
                />
              </div>
            </Row>
          </Col>
        </Row>
      </main>
    </Container>
  )
}
export default EsstComponent
